function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsAiassistantRootcauseanalysisIcon = function SvgNewcsAiassistantRootcauseanalysisIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.14 9.18c-.56 0-.93.19-1.29.56L7.08 6.98c.19-.37.19-.74.19-1.1s0-.56-.19-.93l3.31-1.65c.37.37.93.56 1.28.56 1.1 0 2.03-.93 2.03-2.03s-.74-1.84-1.84-1.84S9.83.92 9.83 2v.19L6.54 3.85c-.56-.73-1.47-1.29-2.57-1.29-1.82 0-3.3 1.46-3.31 3.28v.03c0 1.47.93 2.57 2.2 3.13l-.56 2.94c-.93.19-1.66.93-1.66 2.03S1.57 16 2.65 16s2.03-.93 2.03-2.03c0-.74-.37-1.47-1.1-1.66l.56-3.13c.93 0 1.84-.56 2.39-1.1l4.78 2.76v.37c0 1.12.91 2.02 2.03 2.03 1.1 0 2.03-.93 2.03-2.03-.21-1.12-1.12-2.03-2.22-2.03Z",
    style: {
      fill: "#ff5461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z",
    style: {
      fill: "none"
    }
  }));
};
export default SvgNewcsAiassistantRootcauseanalysisIcon;